import * as Roles from "@/constants/roles";

const ALL_ROLES = [
  Roles.CREDIT,
  Roles.PRICING_TEAM,
  Roles.TELNET,
  Roles.CUSTOMER_MANAGER,
  Roles.LOYALTY_MARKETING,
  Roles.SUPPORT
];

export const LOYALTY_ROUTE_NAMES: any = {
  CUSTOMERS: "loyalty-customers",
  CUSTOMER_DETAILS: "loyalty-customer-details",
  SEGMENT_OFFERS: "loyalty-segment-offers",
  SEGMENT_OFFER_DETAILS: "loyalty-segment-offer-details",
  ACCOUNT_OFFERS: "loyalty-account-offers",
  ACCOUNT_OFFERS_DETAILS: "loyalty-account-offers-details",
  POINTS: "loyalty-points",
  CAMPAIGNS: "loyalty-campaigns",
  CAMPAIGNS_DETAILS: "loyalty-campaigns-details",
};

export const LOYALTY_ROUTES = [
  {
    name: LOYALTY_ROUTE_NAMES.CUSTOMERS,
    path: "/loyalty/customers",
    component: () =>
      import(/* webpackChunkName: "loyaltyCustomers" */ "./views/Loyalty/Customers.vue"),
    meta: {
      display: "Loyalty",
      requireRole: ALL_ROLES,
      parentName: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      submenu: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      label: "Customer management",
      sortOrder: 1
    }
  },
  {
    name: LOYALTY_ROUTE_NAMES.CUSTOMER_DETAILS,
    path: "/loyalty/customers/detail/:id?",
    props: true,
    component: () =>
      import(/* webpackChunkName: "loyaltyCustomerDetails" */ "./views/Loyalty/CustomerDetails.vue"),
    meta: {
      requireRole: ALL_ROLES,
      parentName: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      submenu: LOYALTY_ROUTE_NAMES.CUSTOMERS
    }
  },
  {
    name: LOYALTY_ROUTE_NAMES.SEGMENT_OFFERS,
    path: "/loyalty/segment-offers",
    component: () =>
      import(/* webpackChunkName: "loyaltySegmentOffers" */ "./views/Loyalty/SegmentOffers.vue"),
    meta: {
      requireRole: ALL_ROLES,
      parentName: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      submenu: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      label: "Loyalty segment offers",
      sortOrder: 2
    }
  },
  {
    name: LOYALTY_ROUTE_NAMES.SEGMENT_OFFER_DETAILS,
    path: "/loyalty/segment-offers/detail/:id?",
    props: true,
    component: () =>
      import(/* webpackChunkName: "loyaltySegmentOfferDetails" */ "./views/Loyalty/SegmentOfferDetails.vue"),
    meta: {
      requireRole: ALL_ROLES,
      parentName: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      submenu: LOYALTY_ROUTE_NAMES.CUSTOMERS
    }
  },
  {
    name: LOYALTY_ROUTE_NAMES.ACCOUNT_OFFERS,
    path: "/loyalty/special-offers",
    component: () =>
      import(/* webpackChunkName: "loyaltySpecialOffers" */ "./views/Loyalty/AccountOffers.vue"),
    meta: {
      requireRole: ALL_ROLES,
      parentName: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      submenu: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      label: "Loyalty special offers",
      sortOrder: 3
    }
  },
  {
    name: LOYALTY_ROUTE_NAMES.ACCOUNT_OFFERS_DETAILS,
    path: "/loyalty/special-offers/detail/:id?",
    props: true,
    component: () =>
      import(/* webpackChunkName: "loyaltySpecialOfferDetails" */ "./views/Loyalty/AccountOfferDetails.vue"),
    meta: {
      requireRole: ALL_ROLES,
      parentName: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      submenu: LOYALTY_ROUTE_NAMES.CUSTOMERS
    }
  },
  {
    name: LOYALTY_ROUTE_NAMES.CAMPAIGNS,
    path: "/loyalty/campaigns",
    component: () =>
      import(/* webpackChunkName: "loyaltyCampaigns" */ "./views/Loyalty/Campaigns.vue"),
    meta: {
      requireRole: ALL_ROLES,
      parentName: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      submenu: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      label: "Commercial campaigns",
      sortOrder: 4
    }
  },
  {
    name: LOYALTY_ROUTE_NAMES.CAMPAIGNS_DETAILS,
    path: "/loyalty/campaigns/detail/:id?",
    props: true,
    component: () =>
      import(/* webpackChunkName: "loyaltyCampaignDetails" */ "./views/Loyalty/CampaignDetails.vue"),
    meta: {
      requireRole: ALL_ROLES,
      parentName: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      submenu: LOYALTY_ROUTE_NAMES.CUSTOMERS
    }
  },
  {
    name: LOYALTY_ROUTE_NAMES.POINTS,
    path: "/loyalty/customers/points/:id",
    props: true,
    component: () =>
      import(/* webpackChunkName: "loyaltyPoints" */ "./views/Loyalty/Points.vue"),
    meta: {
      requireRole: ALL_ROLES,
      parentName: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      submenu: LOYALTY_ROUTE_NAMES.CUSTOMERS
    }
  },
];
